import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ref, onUnmounted, onMounted } from 'vue';

export const useBenefitsMobile = () => {
  const wrapperRef = ref<HTMLElement | null>(null);

  const titleRef = ref<HTMLElement | null>(null);

  gsap.registerPlugin(ScrollTrigger);
  const matchMediaRef = ref<ReturnType<typeof gsap.matchMedia>>();

  const initAnimation = () => {
    if (!wrapperRef.value || !titleRef.value) return;

    const cards = gsap.utils.toArray('.benefit-card');
    if (!cards || !cards.length) return;

    const matchMedia = gsap.matchMedia();

    matchMediaRef.value = matchMedia.add('(max-width: 1023px)', () => {
      gsap.set(titleRef.value, {
        opacity: 0
      });

      gsap.set(cards, {
        opacity: 0,
        position: 'absolute',
        x: +50
      });

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: '.benefits-section',
          start: 'center center',
          end: '+=200%',
          scrub: 1,
          pin: true,
          markers: false,
          invalidateOnRefresh: true
        }
      });

      timeline.to(titleRef.value, {
        opacity: 1,
        duration: 0.1,
        ease: 'power2.out'
      });

      cards.forEach((card, index) => {
        const step = index * 1.2;

        timeline.to(
          [card],
          {
            opacity: 1,
            x: 0,
            duration: 0.5
          },
          step
        );

        if (index < cards.length - 1) {
          timeline.to(
            [card],
            {
              opacity: 0,
              x: -50,
              duration: 0.5
            },
            step + 1
          );
        }
      });
    });
  };

  onMounted(() => {
    initAnimation();
  });

  onUnmounted(() => {
    matchMediaRef.value?.revert();
    matchMediaRef.value = undefined;
  });

  return {
    wrapperRef,
    titleRef
  };
};
